export const SATOSHI_IN_BTC = 100000000;
